const questions = [
  { question: "Thủ đô của Việt Nam ở đâu?", answer: [21.0285, 105.8542] },
  { question: "Thành phố Hồ Chí Minh ở đâu?", answer: [10.7769, 106.7009] },
  { question: "Thành phố Đà Nẵng ở đâu?", answer: [16.0471, 108.2065] },
  { question: "Thành phố Huế ở đâu?", answer: [16.4637, 107.5909] },
  { question: "Thành phố Hải Phòng ở đâu?", answer: [20.8449, 106.6881] },
  { question: "Thành phố Cần Thơ ở đâu?", answer: [10.0452, 105.7469] },
  { question: "Thành phố Nha Trang ở đâu?", answer: [12.2388, 109.1962] },
  { question: "Thành phố Vũng Tàu ở đâu?", answer: [10.345, 107.0843] },
  { question: "Thành phố Đà Lạt ở đâu?", answer: [11.9404, 108.4583] },
  { question: "Thành phố Buôn Ma Thuột ở đâu?", answer: [12.6664, 108.0378] },
  { question: "Thành phố Quy Nhơn ở đâu?", answer: [13.782, 109.2197] },
  { question: "Thành phố Thanh Hóa ở đâu?", answer: [19.8067, 105.7852] },
  { question: "Thành phố Vinh ở đâu?", answer: [18.6796, 105.681] },
  { question: "Thành phố Bắc Ninh ở đâu?", answer: [21.1861, 106.0763] },
  { question: "Thành phố Thái Nguyên ở đâu?", answer: [21.5942, 105.8482] },
  { question: "Thành phố Lào Cai ở đâu?", answer: [22.4856, 103.9707] },
  { question: "Thành phố Việt Trì ở đâu?", answer: [21.3223, 105.4011] },
  { question: "Thành phố Hạ Long ở đâu?", answer: [20.9503, 107.0733] },
  { question: "Thành phố Nam Định ở đâu?", answer: [20.4388, 106.1621] },
  { question: "Thành phố Phan Thiết ở đâu?", answer: [10.9333, 108.1] },
  { question: "Thành phố Bạc Liêu ở đâu?", answer: [9.2941, 105.7278] },
  { question: "Thành phố Rạch Giá ở đâu?", answer: [10.0125, 105.0809] },
  { question: "Thành phố Mỹ Tho ở đâu?", answer: [10.36, 106.3605] },
  { question: "Thành phố Sóc Trăng ở đâu?", answer: [9.6025, 105.9719] },
  { question: "Thành phố Hà Tĩnh ở đâu?", answer: [18.3428, 105.9057] },
  { question: "Thành phố Tam Kỳ ở đâu?", answer: [15.573, 108.474] },
  { question: "Thành phố Pleiku ở đâu?", answer: [13.9788, 108.0105] },
  { question: "Thành phố Tây Ninh ở đâu?", answer: [11.3356, 106.1039] },
  { question: "Thành phố Sơn La ở đâu?", answer: [21.3294, 103.9144] },
  { question: "Thành phố Lạng Sơn ở đâu?", answer: [21.8526, 106.7616] },
  { question: "Thành phố Điện Biên Phủ ở đâu?", answer: [21.3841, 103.0215] },
  { question: "Thành phố Cao Bằng ở đâu?", answer: [22.6643, 106.259] },
  { question: "Thành phố Yên Bái ở đâu?", answer: [21.705, 104.8722] },
  { question: "Thành phố Bắc Giang ở đâu?", answer: [21.2723, 106.1946] },
  { question: "Thành phố Tuyên Quang ở đâu?", answer: [21.8236, 105.214] },
  { question: "Thành phố Phủ Lý ở đâu?", answer: [20.5441, 105.913] },
  { question: "Thành phố Hưng Yên ở đâu?", answer: [20.6462, 106.051] },
  { question: "Thành phố Bến Tre ở đâu?", answer: [10.2415, 106.3759] },
  { question: "Thành phố Trà Vinh ở đâu?", answer: [9.9347, 106.345] },
  { question: "Thành phố Vĩnh Long ở đâu?", answer: [10.2537, 105.9722] },
  { question: "Thành phố Long Xuyên ở đâu?", answer: [10.3864, 105.4352] },
  { question: "Thành phố Châu Đốc ở đâu?", answer: [10.7009, 105.117] },
  { question: "Thành phố Hà Giang ở đâu?", answer: [22.8283, 104.9784] },
  { question: "Thành phố Kon Tum ở đâu?", answer: [14.3498, 108.0076] },
  {
    question: "Thành phố Phan Rang-Tháp Chàm ở đâu?",
    answer: [11.5643, 108.991],
  },
  { question: "Thành phố Cam Ranh ở đâu?", answer: [11.902, 109.1618] },
  { question: "Thành phố Đồng Hới ở đâu?", answer: [17.4688, 106.6223] },
  { question: "Thành phố Đông Hà ở đâu?", answer: [16.8163, 107.1006] },
  { question: "Thành phố Uông Bí ở đâu?", answer: [21.0335, 106.787] },
  { question: "Thành phố Cẩm Phả ở đâu?", answer: [21.011, 107.2772] },
];

export default questions;
